module.exports = global["Globalize"] = require("-!./globalize.min.js");


//////////////////
// WEBPACK FOOTER
// ./lib/globalize/globalize.min.js-exposed
// module id = 20
// module chunks = 86 87